import Resource from '../utils/resource'
export default new Resource('/api/v1/project')
